// @ts-nocheck
// Defining globle value
const videoPopOpenButton = document.querySelectorAll('.WI_videoPop_opener');
const videoPopCloseButton = document.querySelector('.WI_videoPop_cls');
const videoPopLoading = document.querySelector('.WI_videoPop_body_loading');
const videoPopVideo = document.querySelector('.WI_videoPop_body_video video');
const videoPopVideoSource = document.querySelector('.WI_videoPop_body_video video source');


class WIvideopop extends HTMLElement {
    constructor () {
        super();
    }
    
    connectedCallback() {
        this.openVideoPop();
        this.close();
        this.videoPlay();
        this.addEventListener('click', this.bgClose.bind(this));
    }

    // All classes
    allclasses() {
    }
    
    // video pop opener 
    openVideoPop() {
         videoPopOpenButton.forEach(b => {
           b.addEventListener('click', (e)=>{
                e.preventDefault();
                document.dispatchEvent(new CustomEvent("open:background", { bubbles: true }));
                this.style.display = "flex";
           });
        }); 
    }

    // video pop close
    closeVideoPop() {
        this.videoPause();
        this.style.display = "none";
        document.dispatchEvent(new CustomEvent("close:background", { bubbles: true }));
    }

    // close button click
    close() {
        videoPopCloseButton.addEventListener('click', ()=>{
            this.closeVideoPop();
        });
    }

    // close background click
    bgClose(event) {
        if (event.target.matches('wi-video-pop')) {
                this.closeVideoPop();
        }
    }

    // video play
    videoPlay() {
        videoPopOpenButton.forEach(b => {
            b.addEventListener('click', ()=>{
                let dataS = b.getAttribute('data-item');
                videoPopVideoSource.src = dataS;
                videoPopVideo.load();
                videoPopVideo.play();
                videoPopLoading.style.display = "none";
            });
        });
    }

    // video pause
    videoPause() {
        videoPopVideoSource.src = "";
        videoPopVideo.load();
        videoPopVideo.play();
    }
}

customElements.define("wi-video-pop", WIvideopop);